import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import { UserAccess } from 'components/user-access';
import { PageRestricted } from 'pages/errors/page-restricted';
import { Breadcrumbs, Tabs } from 'components/navigation';
import { LinkButton } from 'components/buttons';

import { importUploadActions } from './bulkImportTypes';

const defaultArray = [];

// The tab list is URL-driven: each tab maps to its own route so the selection survives a
// refresh and can be linked to directly. Clicking a tab navigates rather than toggling
// local state.
const tabDefinitions = [
    { title: "Import History", path: "/import/bulk" },
    { title: "Saved Mappings", path: "/import/bulk/mappings" }
];

// The shared shell for the bulk import landing area. It owns the page gate, heading, New
// Import button, and the tab strip; each tab's route renders this shell with its own panel
// as children so the History and Saved Mappings pages stay consistent.
export function BulkImports(
    {
        breadcrumbs = defaultArray,
        selectedTabIndex = 0,
        children = null
    }
) {
    const navigate = useNavigate();

    const tabs = tabDefinitions.map((tab, index) => {
        return { title: tab.title, selected: index === selectedTabIndex };
    });

    function onTabClick(index) {
        if (index !== selectedTabIndex) {
            navigate(tabDefinitions[index].path);
        }
    }

    return (
        <UserAccess
            perform={importUploadActions}
            yes={() => (
                <div className="row">
                    <Breadcrumbs items={breadcrumbs} />

                    <h1>Bulk Imports</h1>

                    <div className="button-row button-row-stacked-mobile spacer-bottom">
                        <LinkButton intent="primary" text="New Import" icon="plus" href="/import/bulk/new" id="new-bulk-import" />
                    </div>

                    <div className="spacer-bottom">
                        <Tabs tabs={tabs} onClick={onTabClick} />
                    </div>

                    {children}
                </div>
            )}
            no={() => (
                <PageRestricted />
            )}
        />
    );
}

BulkImports.propTypes = {
    breadcrumbs: PropTypes.array,
    selectedTabIndex: PropTypes.number,
    children: PropTypes.node
};
